module.exports = __webpack_public_path__ + "img/play.1eaf2984.svg";